import React from 'react';
import { FULFILLMENT_TYPES } from './constants';
import { DeliveryAddressDetails } from './DeliveryAddressDetails';
import { StorePickupDetails } from './StorePickupDetails';

// Ported one-to-one from @thd-olt-component-react/active-orders' FulfillmentAddressDetails.tsx
// (OOP-4059) — see FulfillmentDetailsDrawer.tsx's doc comment.
const DELIVERY_FULFILLMENT_TYPES: string[] = [
  FULFILLMENT_TYPES.SHIP_TO_HOME,
  FULFILLMENT_TYPES.BUY_ONLINE_DELIVER_FROM_STORE,
  FULFILLMENT_TYPES.APPLIANCE
];
const PICKUP_FULFILLMENT_TYPES: string[] = [FULFILLMENT_TYPES.BUY_ONLINE_SHIP_TO_STORE, FULFILLMENT_TYPES.BUY_ONLINE_PICKUP_IN_STORE];

const isDeliveryFulfillmentType = (type: string) => DELIVERY_FULFILLMENT_TYPES.includes(type);
const isPickupFulfillmentType = (type: string) => PICKUP_FULFILLMENT_TYPES.includes(type);

export interface FulfillmentAddressDetailsProps {
  fulfillmentGroup: any;
}

export const FulfillmentAddressDetails: React.FC<FulfillmentAddressDetailsProps> = ({ fulfillmentGroup }) => {
  const { fulfillmentType } = fulfillmentGroup || {};

  if (!fulfillmentType) {
    return null;
  }

  if (isDeliveryFulfillmentType(fulfillmentType)) {
    const { shippingAndHandling, bodfsDeliveryAndHandling } = fulfillmentGroup;
    const deliveryDetails = shippingAndHandling ?? bodfsDeliveryAndHandling?.bodfsDeliveries?.[0] ?? {};

    return <DeliveryAddressDetails deliveryDetails={deliveryDetails} />;
  }

  if (isPickupFulfillmentType(fulfillmentType)) {
    return <StorePickupDetails storePickup={fulfillmentGroup?.storePickup} />;
  }

  return null;
};
